<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-50 space-y-2 print:hidden">
      <TransitionGroup name="notification" tag="div">
        <div
          v-for="notification in notifications"
          :key="notification.id"
          :class="getNotificationClasses(notification.type)"
          class="notification max-w-sm w-full p-4 animate-slide-in-right"
        >
          <div class="flex items-start">
            <!-- Иконка -->
            <div class="flex-shrink-0">
              <CheckCircleIcon
                v-if="notification.type === 'success'"
                class="h-5 w-5 text-success-400"
              />
              <XCircleIcon
                v-else-if="notification.type === 'error'"
                class="h-5 w-5 text-danger-400"
              />
              <ExclamationTriangleIcon
                v-else-if="notification.type === 'warning'"
                class="h-5 w-5 text-warning-400"
              />
              <InformationCircleIcon
                v-else
                class="h-5 w-5 text-primary-400"
              />
            </div>
            
            <!-- Контент -->
            <div class="ml-3 flex-1">
              <p class="text-sm font-medium text-gray-900">
                {{ notification.message }}
              </p>
            </div>
            
            <!-- Кнопка закрытия -->
            <div class="ml-4 flex-shrink-0">
              <button
                @click="hideNotification(notification.id)"
                class="rounded-md bg-white text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                <XMarkIcon class="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/vue/24/outline'
import { useNotifications } from '@/composables/useNotifications'

const { notifications, hideNotification } = useNotifications()

const getNotificationClasses = (type) => {
  const baseClasses = 'notification shadow-lg'
  
  switch (type) {
    case 'success':
      return `${baseClasses} notification-success`
    case 'error':
      return `${baseClasses} notification-error`
    case 'warning':
      return `${baseClasses} notification-warning`
    default:
      return `${baseClasses} border-l-4 border-primary-400`
  }
}
</script>

<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-move {
  transition: transform 0.3s ease;
}
</style>